import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'white-outline';
  icon?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  icon = false,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 rounded-lg font-semibold transition-all duration-200 text-lg';
  const variants = {
    primary: 'bg-brand-orange hover:bg-brand-orange-hover text-white shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    secondary: 'bg-white text-brand-blue hover:bg-gray-50 border border-transparent shadow-md',
    outline: 'bg-transparent border-2 border-brand-orange text-brand-orange hover:bg-brand-orange hover:text-white',
    'white-outline': 'bg-transparent border-2 border-white text-white hover:bg-white hover:text-brand-blue'
  };
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-250">
      {children}
      {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-251" />}
    </motion.button>;
}